import { render } from "./turmaView.vue?vue&type=template&id=187b1fb6&scoped=true&bindings={\"id\":\"props\",\"currentClass\":\"setup\"}"
import script from "./turmaView.vue?vue&type=script&lang=js"
export * from "./turmaView.vue?vue&type=script&lang=js"

import "./turmaView.vue?vue&type=style&index=0&id=187b1fb6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-187b1fb6"

export default script